import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {ChevronRight, Sparkles} from 'lucide-react';
import {cn} from '@chekinapp/ui';
import illustration from './assets/travel-guide.webp';

type TravelGuideBannerProps = {
  to: string;
  onClick?: () => void;
  className?: string;
};

export function TravelGuideBanner({to, onClick, className}: TravelGuideBannerProps) {
  const {t} = useTranslation();

  return (
    <Link
      to={to}
      onClick={onClick}
      data-testid="travel-guide-banner"
      className={cn(
        'group relative flex min-h-[112px] w-full items-center overflow-hidden',
        'rounded-[var(--chekin-radius-lg)]',
        className,
      )}
    >
      <img
        src={illustration}
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-right transition-transform duration-500 group-hover:scale-[1.03]"
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-transparent"
      />

      <div className="relative flex min-w-0 flex-col px-5 py-4">
        <span className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.12em] text-white/85">
          <Sparkles size={13} strokeWidth={2.2} />
          {t('travel_guide.banner_eyebrow')}
        </span>
        <span className="mt-1 text-[19px] font-bold leading-tight tracking-[-0.01em] text-white">
          {t('travel_guide.banner_title')}
        </span>
        <span className="mt-1 max-w-[80%] text-[13px] leading-snug text-white/85">
          {t('travel_guide.banner_subtitle')}
        </span>
      </div>

      <ChevronRight
        size={22}
        strokeWidth={2.2}
        className="relative ml-auto mr-4 shrink-0 text-white/90 transition-transform group-hover:translate-x-0.5"
      />
    </Link>
  );
}
